import { Avatar, Button, FormGroup, IconButton, Input, InputAdornment, InputLabel, makeStyles, Typography } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import React, { useContext, useState } from "react";
import { Fragment } from "react";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { useHistory } from "react-router-dom";
import { authContext } from "./FPERouter";
import { useAlert } from "./hooks/useAlert";

const useStyles = makeStyles(theme => ({
  paper: {
    paddingTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main
  },
  margin: {
    margin: theme.spacing(1),
  }
}));
  
function LoginPage() {

  const auth = useContext(authContext);
  const {showError} = useAlert();

  const classes = useStyles();
  const [values, setValues] = useState({
    id: '',
    password: '',
    showPassword: false,
  });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };
  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleKeyDown = (event) => {
    if(event.keyCode === 13 && values.id !== "" && values.password !== "") {
      login();
    }
  }

  const history = useHistory();

  const {from} = {from: {pathname: `${window.location.pathname}`}};
  const login = () => {
    auth.signIn(values, (ret) => {
      if(ret) {
        history.replace(from);
      } else {
        showError('Login failed.', {timeout: 2000, close: false});
      }
    });
  }

  return (
    <div className={classes.paper}>
      <Fragment>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Flight Plan Editor
        </Typography>
        <form>
          <FormGroup className={classes.margin}>
            <InputLabel htmlFor="id">Id</InputLabel>
            <Input
              id="id"
              type="text"
              value={values.id}
              onChange={handleChange('id')}
              onKeyDown={handleKeyDown}
              autoFocus={true}
            />
          </FormGroup>
          <FormGroup className={classes.margin}>
            <InputLabel htmlFor="password">Password</InputLabel>
            <Input
              id="password"
              type={values.showPassword ? 'text' : 'password'}
              value={values.password}
              onChange={handleChange('password')}
              onKeyDown={handleKeyDown}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormGroup>
          <Button
              type="button"
              variant="contained"
              color="primary"
              disabled={values.id === "" || values.password === ""}
              fullWidth
              onClick={login}
            >
              Login
            </Button>
        </form>
      </Fragment>
    </div>
  );
}

export default LoginPage;
